import { describeNotificationError, type NotificationErrorDescription } from "../../utils/adminNotificationForm";

/** User-surface wording on top of the shared gateway error mapping (spec Section 3.3). */
export function describeUserNotificationError(error: unknown): NotificationErrorDescription {
  const described = describeNotificationError(error);
  if (described.kind === "forbidden") {
    return { ...described, message: "You do not have access to notifications." };
  }
  return described;
}
